/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { ArrowNarrowLeftIcon, ArrowNarrowRightIcon } from '@heroicons/react/solid';
import PropTypes from 'prop-types';
import { joinClassNames } from 'utils/cssHelper';
import { usePagination, DOTS } from './usePagination';

const Pagination = ({
  onPageChanged,
  totalCount,
  siblingCount,
  currentPage,
  pageSize,
}) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  /*
  if (currentPage === 0 || !paginationRange || paginationRange.length < 2) {
    return null;
  } */

  const onNext = (e) => {
    e.preventDefault();
    onPageChanged(currentPage + 1);
  };

  const onPrevious = (e) => {
    e.preventDefault();
    onPageChanged(currentPage - 1);
  };

  const onPageChange = (e, pageNumber) => {
    e.preventDefault();

    if (onPageChanged) {
      onPageChanged(pageNumber);
    }
  };

  const lastPage = paginationRange && paginationRange.length > 0 ? paginationRange[paginationRange.length - 1] : 1;

  return (
    <nav className="border-t border-gray-200 px-4 flex items-center justify-between sm:px-0">
      <div className="-mt-px w-0 flex-1 flex">
        <a
          href="/"
          className={joinClassNames(
            'border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium hover:text-gray-700 hover:border-gray-300',
            currentPage === 1 ? 'pointer-events-none text-gray-300' : 'text-gray-500',
          )}
          onClick={onPrevious}
        >
          <ArrowNarrowLeftIcon
            className={joinClassNames(
              'mr-3 h-5 w-5 ',
              currentPage === 1 ? 'text-gray-200' : 'text-gray-400',
            )}
            aria-hidden="true"
          />
          Previous
        </a>
      </div>
      <div className="hidden md:-mt-px md:flex">
        {(paginationRange || []).map((pageNumber) => {
          if (pageNumber === DOTS) {
            return (
              <span key={pageNumber} className="border-transparent text-gray-500 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium">
                &#8230;
              </span>
            );
          }

          return (
            <a
              key={pageNumber}
              href="/"
              className={joinClassNames(
                'border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium',
                pageNumber === currentPage
                  ? 'border-indigo-500 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
              )}
              onClick={(e) => onPageChange(e, pageNumber)}
              aria-current="page"
            >
              {pageNumber}
            </a>
          );
        })}
      </div>
      <div className="-mt-px w-0 flex-1 flex justify-end">
        <a
          href="/"
          onClick={onNext}
          className={joinClassNames(
            'border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium hover:text-gray-700 hover:border-gray-300',
            currentPage === lastPage ? 'pointer-events-none text-gray-300' : 'text-gray-500',
          )}
        >
          Next
          <ArrowNarrowRightIcon
            className={joinClassNames(
              'ml-3 mr-3 h-5 w-5 ',
              currentPage === lastPage ? 'text-gray-200' : 'text-gray-400',
            )}
            aria-hidden="true"
          />
        </a>
      </div>
    </nav>
  );
};

Pagination.defaultProps = {
  __TYPE: 'Paging',
  currentPage: PropTypes.number,
  totalCount: PropTypes.number,
  onPageChanged: PropTypes.func,
  // pageSize: PropTypes.number,
  // siblingCount: PropTypes.number,
};

export { Pagination };
